<template>
    <Structure_NoTabs>
        <template v-slot:header>
            <Story_Header
                :story="story"
                :lastSave="lastSave"
            />
        </template>
        <template v-slot:content>
            <Story_Content
                :story="story"
            />
        </template>
    </Structure_NoTabs>
</template>

<script>
import {story} from "@/class/story";
import Story_Header from "@/views/story/Story_Header";
import Story_Content from "@/views/story/Story_Content";
import Story_InteractivesImages from "@/views/story/Story_Cards";
import Structure_NoTabs from "@/views/structures/Structure_NoTabs";
import Template from "@/layouts/Template";
import {saveContentOnglet} from "@/class/onglets/onglet";
import nav from "@/class/nav/nav";

export default {
    name: "Story",
    components: {Template, Structure_NoTabs, Story_InteractivesImages, Story_Content, Story_Header},
    data(){
        return {
            story:new story(),
            loadingData:false,
            
            lastSave: -1,
        }
    },
    methods:{
        async start(){
            this.story = new story();
            // this.story.voletsContent.removeByType("annotation");
            
            this.loading(true);
            
            let storyId = this.$route.params.storyId || 0;
            
            if(saveContentOnglet.objectExist(this.story.objectType,storyId)){
                
                this.story = saveContentOnglet.objectGet(this.story.objectType,storyId)
                
                nav.addStory(this.story)
                
                await this.$nextTick()
                
                this.loading(false);
                return;
            }
    
            if (storyId) {
                console.log("- id : " + storyId);
                this.story.setId(storyId);
                this.story.setStoryId(storyId);
            } else {
                console.log("- create new");
            }
    
            if(!await this.story.load()){
                return this.loading(false)
            }
            
            
            this.story.historyAdd();
            nav.addStory(this.story)
            this.loading(false)
    
            saveContentOnglet.objectSave(this.story)
        },
        loading(toggle){
            this.loadingData = toggle;
            
            if(this.loadingData) {
                this.$vs.loading({
                    container: this.$refs.content,
                    scale: 0.5
                })
            }else{
                this.$vs.loading.close(this.$refs.content)
            }
            
        },
    },
    mounted() {
        this.start()
    }
}
</script>